import React from "react";
import Header from "./Header";
import UsersHub from "../admin/UsersHub";

export default function LayoutUsersHub() {
  return (
    <>
      <Header />
      <UsersHub />
    </>
  );
}
